import { FunctionComponent } from "react";
import Page from "@/components/Page";
import styles from "./styles.module.css";
import Link from "next/link";
import Meta from "@/components/Meta";
import { GetNumOfProjects } from "@/utils/_app/getNumOfProjects";
import NavigationPresetDefault from "@/components/Navigation/Preset/Default";

const Custom404: FunctionComponent<GetNumOfProjects> = () => {
  return (
    <Page navigation={NavigationPresetDefault}>
      <Meta
        type={"404"}
        title={"404 - Stránka nenájdená"}
        description={
          "Chybová hláška protokolu HTTP: 404 - Page Not Found (Stránka nenájdená)."
        }
      />

      <div className={styles.container}>
        <div className={styles.heading}>Nenájdené!</div>
        <div className={styles.subheading}>
          Stránka, ktorú hľadáte <strong>neexistuje</strong>.
        </div>
        <div className={styles.subheading}>
          Chybová hláška HTTP: 404 - Page Not Found (Stránka nenájdená).
        </div>
        <Link href={"/"} legacyBehavior>
          <button className={styles.button}>Späť na domovskú stránku</button>
        </Link>
      </div>
    </Page>
  );
};

export default Custom404;
